import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom"; // Import useParams to get the URL slug
import Header from "../pages/header";
import Footer from "../pages/footer";
import { getCompanyBySlug } from "../../services/companies";

const Company = () => {
  // 1. Get the slug from the URL (e.g., "ryientsoft-technologies")
  const { slug } = useParams();

  // 2. State to hold data
  const [companyData, setCompanyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 3. Fetch data when the component mounts or the slug changes
  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        setLoading(true);
        // Replace with your actual API endpoint
        // Example: http://localhost:5000/api/companies/ryientsoft-technologies
        // const response = await axios.get(`http://localhost:5000/api/companies/${slug}`);
        const response = await getCompanyBySlug(slug).then((res) => res.json());
        setCompanyData(response.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching company data:", err);
        setError("Could not load company details.");
        setLoading(false);
      }
    };

    if (slug) {
      fetchCompanyData();
    }
  }, [slug]);

  // 4. Handle Loading and Error states
  // if (loading) return <div className="text-center p-5">Loading...</div>;
  // if (error) return <div className="text-center p-5 text-danger">{error}</div>;

  return (
    <>
      <Header />

      {/* Dynamic Company Details Section */}
      <div className="container-fluid py-5 bg-light">
        <div className="container">
          {/* Displaying the fetched data */}
          <div className="row mb-5">
            <div className="col-12">
              <h1>{companyData?.name || slug}</h1>
              <p className="lead">
                {companyData?.description || "No description available."}
              </p>
              {companyData?.location && (
                <p>
                  <strong>Location:</strong> {companyData.location}
                </p>
              )}
              {companyData?.website && (
                <a
                  href={companyData.website}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-primary"
                >
                  Visit Website
                </a>
              )}
            </div>
          </div>

          {/* Your original "Ready to Get Started" Block */}
          <div
            className="bg-primary rounded p-5 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div className="row g-4 align-items-center">
              <div className="col-lg-6 text-center text-lg-start">
                <h2 className="text-white mb-4">
                  Ready to apply at {companyData?.name}?
                </h2>
                <p className="text-white mb-0 lead">
                  Join thousands of employers and candidates who trust us to
                  find the perfect match.
                </p>
              </div>
              <div className="col-lg-6 text-center text-lg-end">
                <a
                  className="btn btn-light py-3 px-5 me-3 fw-bold"
                  href="#register"
                >
                  Find a Job
                </a>
                <a
                  className="btn btn-outline-light py-3 px-5 fw-bold"
                  href="#post-job"
                >
                  Post a Job
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Company;
